import Icon, { IconName } from "components/atoms/Icon";
import React from "react";
import "./index.scss";

export interface CheckboxButtonProps {
  iconName?: IconName;
  title?: string;
  description?: string;
  special?: boolean;
}

export const Box: React.FC<CheckboxButtonProps> = ({
  iconName,
  title,
  description,
  children,
  special,
}) => (
  <div className="m-box">
    <div className="m-box_header">
      <div className="m-box_wraptitle">
        {iconName && <Icon iconName={iconName} />}
        <div className="m-box_title">{title}</div>
      </div>
      {description && <div className="m-box_description">{description}</div>}
    </div>
    <div className={`m-box_content ${special && "special"}`}>{children}</div>
  </div>
);
